// libraries
import { Badge, Dropdown } from "react-bootstrap";

// utils
import { formatPrice } from "@utils/formatPrice.utils";

// types
import {
  ModelResult,
  PredictionPublicationPrice,
} from "../interfaces/interfaces";
import { TooltipInfo } from "@shared/TooltipInfo/TooltipInfo";

interface Props {
  dataVim: ModelResult;
  onSelect: (option: PredictionPublicationPrice) => void;
  optimalPrice: number | null;
  options: PredictionPublicationPrice[];
  selectedOption: PredictionPublicationPrice | null;
}

export const PriceOptionsDropdown = ({
  dataVim,
  options,
  onSelect,
  selectedOption,
  optimalPrice,
}: Props) => {
  const isSuggestion = selectedOption?.precio_nuevo === optimalPrice;

  return (
    <Dropdown>
      <div className="d-flex justify-content-between mb-1 current-price">
        <div>Precio actual de publicación</div>
        <div>{formatPrice(dataVim.precio_actual_de_publicacion)}</div>
      </div>
      <div className="d-flex gap-2 align-items-center justify-content-between">
        <div className="dropdown-title">Nuevo precio de publicación</div>
        <Dropdown.Toggle>
          <div className="d-flex align-items-center gap-2">
            {selectedOption
              ? formatPrice(selectedOption.precio_nuevo)
              : "Selecciona una opción"}
          </div>
        </Dropdown.Toggle>
      </div>
      <Dropdown.Menu>
        {options.map((option) => {
          const isThisSuggestion = option.precio_nuevo === optimalPrice;
          return (
            <Dropdown.Item
              key={option.precio_nuevo}
              onClick={() => onSelect(option)}
            >
              <div className="d-flex justify-content-between align-items-center gap-2">
                {formatPrice(option.precio_nuevo)}
                {isThisSuggestion && <Badge bg="success">Sugerencia</Badge>}
              </div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
      {isSuggestion && (
        <div className="d-flex gap-2 justify-content-end pt-2 align-items-center">
          <TooltipInfo
            message="Reducción mínima de precio necesaria para que la probabilidad de alcanzar las 'visitas para promesa' sea al menos del 75%."
            placement="top"
          />
          <Badge bg="success">Sugerencia</Badge>
        </div>
      )}
    </Dropdown>
  );
};
